import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as dms from '../dms'

import type { Package } from './package'

export interface Migration {
  type: string // TODO: enum
  payload: unknown // TODO:
}
export namespace Migration {
  /**
   * TODO: explain what this enum is, when it is used and why, as well as any examples
   *
   * TODO: add JSDoc comments to each enum value to explain it
   */
  export enum Type {
    /**
     * Executed by running the given {@link dms.data.query.Query} _before_
     * anything is deployed. That query should return a
     * {@link dms.data.Mutation} which will be applied _after_ all
     * {@link Package.resources} have been deployed
     */
    DmsMutation = 'dms-mutation',
  }
  // Needs to be before namespace is defined
  const TYPES: ReadonlySet<Type> = new Set(Object.values(Type) as Type[])
  export namespace Type {
    export const ALL: readonly Type[] = Array.from(TYPES)
    export const isType = TypeChecker.Factory.oneOf(TYPES)
    export const assertIsType: TypeAsserter<Type> =
      TypeAsserter.Factory.from(isType)
  }

  /**
   * TODO:
   */
  export type Payload<TType extends Type> = {
    [Type.DmsMutation]: {
      query: dms.data.query.Query<dms.data.Mutation>
    }
  }[TType]
}
